import type { DesktopSnapShotBridge } from "@afar-research/contracts";

const SNAP_SHOT_FOCUS_EVENT = "afar-research:focus-composer";

export function dispatchSnapShotComposerFocus(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(SNAP_SHOT_FOCUS_EVENT));
}

export function subscribeSnapShotComposerFocus(listener: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  window.addEventListener(SNAP_SHOT_FOCUS_EVENT, listener);
  return () => window.removeEventListener(SNAP_SHOT_FOCUS_EVENT, listener);
}

export type { DesktopSnapShotBridge };

/**
 * Capture exists only in the Electron shell. Every caller treats `undefined`
 * as "this client cannot capture" rather than branching on the platform.
 */
export function getDesktopSnapShotBridge(): DesktopSnapShotBridge | undefined {
  const snapShot = typeof window === "undefined" ? undefined : window.desktopBridge?.snapShot;
  if (
    typeof snapShot?.requestPermissions !== "function" ||
    typeof snapShot.getState !== "function" ||
    typeof snapShot.setup !== "function" ||
    typeof snapShot.checkShortcut !== "function" ||
    typeof snapShot.setShortcutSuppressed !== "function" ||
    typeof snapShot.listPending !== "function" ||
    typeof snapShot.read !== "function" ||
    typeof snapShot.acknowledge !== "function" ||
    typeof snapShot.onEvent !== "function"
  ) {
    return undefined;
  }

  return snapShot;
}
